<div theme>
  <!-- toolbar -->
  <mat-toolbar class="header-toolbar" [ngClass]="urlChange ? 'profile-page-header' : 'common-page-header'">
    <!-- Logo 170 X 40 dimensions -->
    <!-- REZAYAT  -->
    <img src="assets/images/REZAYAT/logo/full_logo.png" alt="REZAYAT" matTooltip="All Openings"
      *ngIf="innerWidth && orgName === 'REZAYAT'" (click)="openPositions()" height="25" class="header-logo">
    <img src="assets/images/REZAYAT/logo/short_logo.png" alt="REZAYAT" matTooltip="All Openings" height="25"
      *ngIf="!innerWidth  && orgName === 'REZAYAT'" (click)="openPositions()" class="header-logo">

    <!-- ICRISAT  -->
    <img src="assets/images/ICRISAT/logo/full_logo.png" alt="ICRISAT" matTooltip="All Openings"
      *ngIf="innerWidth  && orgName === 'ICRISAT'" (click)="openPositions()" height="50" class="header-logo">
    <img src="assets/images/ICRISAT/logo/short_logo.png" alt="ICRISAT" matTooltip="All Openings" height="25"
      *ngIf="!innerWidth   && orgName === 'ICRISAT'" (click)="openPositions()" class="header-logo">


    <!-- HYPERLOOP  -->
    <img src="assets/images/HYPERLOOP/logo/full_logo.png" alt="HYPERLOOP" matTooltip="All Openings"
      *ngIf="innerWidth && orgName === 'HYPERLOOP'" (click)="openPositions()" height="35" class="header-logo">
    <img src="assets/images/HYPERLOOP/logo/full_logo.png" alt="HYPERLOOP" matTooltip="All Openings" height="25"
      *ngIf="!innerWidth && orgName === 'HYPERLOOP'" (click)="openPositions()" class="header-logo">

    <!-- REZAYAT  -->
    <img src="assets/images/NAQUA/logo/logo.png" alt="NAQUA" matTooltip="All Openings"
      *ngIf="innerWidth && orgName === 'NAQUA'" (click)="openPositions()" height="50" class="header-logo">
    <img src="assets/images/NAQUA/logo/logo.png" alt="NAQUA" matTooltip="All Openings" height="50"
      *ngIf="!innerWidth  && orgName === 'NAQUA'" (click)="openPositions()" class="header-logo">

    <!-- CRESCOWORKS  -->
    <img *ngIf="orgName === 'CRESCOWORKS'" src="assets/images/CRESCOWORKS/logo/full_logo.png" alt="CrescoWorks"
      (click)="openPositions()" class="logo-image header-logo">

    <!-- Icon div which is aligned to right-->
    <div fxFlex fxLayoutAlign="flex-end center" class="header-buttons-gap">

      <!-- <button class="enter-button notranslate login-menu-button" mat-button
        *ngIf="(orgName === 'NAQUA' ||orgName === 'ICRISAT') && currentDisplayLanguage !== 'en'"
        (click)="originalWebsite()">
        <span class="notranslate">English</span>
      </button> -->
      <button id='arabic-button' class="enter-button notranslate" mat-button [matMenuTriggerFor]="language"
        *ngIf="(orgName === 'NAQUA' ||orgName === 'ICRISAT') && isLanguageActive === true && currentDisplayLanguage === 'en'">
        <span class="notranslate">English</span>
        <!-- {{selectedLanguage}} -->
        <!-- !url.includes('_x_tr_sl') -->
        <span><mat-icon class="drop-down-icon" style="transform: translateY(28%)">arrow_drop_down</mat-icon></span>
      </button>

      <button id='arabic-button' class="enter-button notranslate" mat-button [matMenuTriggerFor]="languageTranslate"
        *ngIf="(orgName === 'NAQUA' ||orgName === 'ICRISAT') && isLanguageActive === true && currentDisplayLanguage !== 'en'">
        <!-- <span class="notranslate" *ngIf="currentDisplayLanguage === 'ar'">Arabic</span> -->
        <span class="notranslate" *ngIf="currentDisplayLanguage === 'fr'">French</span>
        <span class="notranslate" *ngIf="currentDisplayLanguage === 'de'">German</span>
        <span class="notranslate" *ngIf="currentDisplayLanguage === 'es'">Spanish</span>
        <span class="notranslate" *ngIf="currentDisplayLanguage === 'it'">Italian</span>
        <!-- !url.includes('_x_tr_sl') -->
        <span><mat-icon class="drop-down-icon" style="transform: translateY(28%)">arrow_drop_down</mat-icon></span>
      </button>
      <mat-menu #languageTranslate="matMenu" class="dropdown-content arabic-menu">
        <button class="notranslate" mat-menu-item (click)="originalWebsite()">
          <span class="notranslate">English</span>
        </button>
      </mat-menu>

      <mat-menu #language="matMenu" class="dropdown-content arabic-menu">
        <!-- <button mat-menu-item (click)="original()" *ngIf="selectedLanguage != 'English'">
          English
        </button> -->
        <!-- <button mat-menu-item (click)="arabic()" class="language-btn">
         Arabic
        </button> -->
        <button mat-menu-item (click)="french()" class="language-btn">
          French
        </button>
        <button mat-menu-item (click)="German()" class="language-btn">
          German
        </button>
        <button mat-menu-item (click)="Spanish()" class="language-btn">
          Spanish
        </button>
        <button mat-menu-item (click)="Italian()" class="language-btn">
          Italian
        </button>

      </mat-menu>

      <!-- open positions mat-flat-button -->
      <button mat-button type="button" matTooltip="All Openings" class="menu-buttons navbar-icon-button"
        (click)="openPositions()" [style.margin-right]="!innerWidth ? '5px' : ''"
        [style.background-color]="navtab === 0 ? 'var(--header-grey)' :'transparent'">
        <mat-icon>home</mat-icon>
      </button>
      <!-- *ngIf="innerWidth"  -->
      <!-- Login mat-flat-button -->
      <button mat-raised-button *ngIf="innerWidth&&!loggedInUsername" type="button" id="translate"
        class="login-menu-button enter-button" (click)="login()">
        Login
      </button>
      <!-- My Account mat-flat-button -->
      <button mat-button class="myAccount navbar-icon-button notranslate" matTooltip="My Account"
        [matMenuTriggerFor]="profile" type="button"
        *ngIf="innerWidth && loggedInUsername && currentDisplayLanguage === 'en'" [matMenuTriggerFor]="profile"
        [style.background-color]="navtab !== 0 ? 'var(--header-grey)' :'transparent'">
        <mat-icon>person</mat-icon>
      </button>

      <!-- Language translate profile button -->
      <button mat-button class="myAccount navbar-icon-button" matTooltip="My Account12" name="translate-profile"
        [matMenuTriggerFor]="translateProfile" *ngIf="innerWidth && loggedInUsername && currentDisplayLanguage !== 'en'"
        [style.background-color]="navtab !== 0 ? 'var(--header-grey)' :'transparent'">
        <mat-icon>person</mat-icon>
      </button>

      <mat-menu overlapTrigger="false" #translateProfile="matMenu" class="toolbar-menus arabic-menu" theme>
        <div>
          <mat-card *ngIf="loggedInUsername" class="user-profile-card">
            <!-- user details -->
            <div class="user-profile-details-wrapper" fxLayout="column" fxLayoutAlign="center center">
              <mat-icon inline="true" class="user-profile-icon">account_circle
              </mat-icon>
              <div class="user-details-wrapper" fxLayout="row" fxLayoutAlign="center center">
                <p class="user-name notranslate" id="translate" matTooltip="{{loggedInUsername}}">{{loggedInUsername}}
                </p>
              </div>
            </div>
          </mat-card>
          <button (click)="originalWebsite()" mat-menu-item *ngIf="loggedInUsername" style="justify-content: center;">
            <a class="track-status-text notranslate" id="translate">Go To Original
              <span class="material-icons notranslate"> north_east </span>
            </a>
            <div class="more-option-text notranslate">
              for more options.
            </div>
          </button>
          <button mat-menu-item class="notranslate" style="justify-content: center;" (click)="logout()" *ngIf="loggedInUsername">
            <span>Logout</span>
          </button>
          <button mat-menu-item (click)="login()" *ngIf="!innerWidth&&!loggedInUsername">
            <span id="translate">Login</span>
          </button>
        </div>
      </mat-menu>

      <!-- Login mat-flat-button -->
      <button mat-raised-button *ngIf="innerWidth && !loggedInUsername && orgName === 'REZAYAT'"
        class="login-menu-button enter-button" style="padding: 5px;
    margin: 5px;" matTooltip="Get Refer for Future Job" (click)="submitProfile()">
        Submit Profile
      </button>

    </div>
    <!--mobile view -->
    <button mat-button class="navbar-icon-button" [matMenuTriggerFor]="profile"
      aria-label="Example icon-button with a menu" *ngIf="!innerWidth && currentDisplayLanguage === 'en'">
      <mat-icon>menu</mat-icon>
    </button>
    <button mat-button class="navbar-icon-button" [matMenuTriggerFor]="translateProfile"
      aria-label="Example icon-button with a menu" *ngIf="!innerWidth && currentDisplayLanguage !== 'en'">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- menu that has the navigation options -->
    <mat-menu overlapTrigger="false" #profile="matMenu" class="toolbar-menus arabic-menu" theme>
      <div>
        <mat-card *ngIf="loggedInUsername" class="user-profile-card">
          <!-- user details -->
          <div class="user-profile-details-wrapper" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon inline="true" class="user-profile-icon">account_circle
            </mat-icon>
            <div class="user-details-wrapper" fxLayout="row" fxLayoutAlign="center center">
              <p class="user-name" id="translate" matTooltip="{{loggedInUsername}}">{{loggedInUsername}}</p>
            </div>
          </div>
        </mat-card>
        <button mat-menu-item class="view-profile-button" *ngIf="loggedInUsername" id="translate"
          (click)="myProfile()"><span>
            Profile</span></button>
        <!-- Home mat-menu-item -->
        <!-- <button mat-menu-item (click)="openPositions()" *ngIf="!innerWidth">
          <span id="translate">Home</span>
        </button> -->
        <!-- Applied Jobs mat-menu-item -->
        <button mat-menu-item (click)="myJobs()" *ngIf="loggedInUsername">
          <span id="translate">My Jobs</span>
        </button>
        <!-- Applied Jobs mat-menu-item -->
        <button mat-menu-item (click)="expandDownloadDialog()" *ngIf="loggedInUsername">
          <span id="translate">My Downloads</span>
        </button>
        <!-- Login mat-menu-item -->
        <button mat-menu-item (click)="login()" *ngIf="!innerWidth&&!loggedInUsername">
          <span id="translate">Login</span>
        </button>
        <!-- Change Password mat-menu-item -->
        <button mat-menu-item (click)="changePassword()" *ngIf="loggedInUsername">
          <span id="translate">Change Password</span>
        </button>

        <!-- <button mat-menu-item (click)="expandJobsourcing()" *ngIf="loggedInUsername">
        <span id="translate">Job Sourcing</span>
      </button> -->


        <!-- <div mat-menu-item *ngIf="loggedInUsername">
        <section class="example-section">
          <span>{{language}}</span>
          <mat-slide-toggle class="example-margin" [(ngModel)]="isChecked" (click)="$event.stopPropagation()"
            (change)="changed($event)">
          </mat-slide-toggle>
        </section>
      </div> -->
        <!-- Logout mat-menu-item -->
        <button mat-menu-item (click)="logout()" *ngIf="loggedInUsername">
          <span>Logout</span>
        </button>
      </div>
    </mat-menu>

    <!-- menu that has the navigation options -->
    <!-- <mat-menu overlapTrigger="false" #languageMenu="matMenu" class="toolbar-menus">
    <div class="align-text">
      Login mat-menu-item
      <button mat-menu-item (click)="translate()">
        <span>Arabic</span>
      </button>
      Change Password mat-menu-item
      <button mat-menu-item (click)="original()">
        <span>English</span>
      </button>
    </div>
  </mat-menu> -->
  </mat-toolbar>
</div>